import type { FC } from 'react';
import { useCallback } from 'react';

import Button from '@trend-dev/trendtech-ui/components/UI/Button';
import { Icon } from '@trend-dev/ui-libs-icons';

import { useYM } from 'YM/Context';
import { GoalType } from 'YM/declare';

import { useRedirectTo } from 'hooks/useRedirectTo';

import { goBackActionText } from '../constants';
import styles from './styles.module.scss';

const GoBack: FC = () => {
    const redirectTo = useRedirectTo();
    const { triggerYM } = useYM();

    const handleClick = useCallback(() => {
        triggerYM({ goal: GoalType.DEVICE_PERMISSION_DENIED_PAGE_CLOSE });
        redirectTo();
    }, []);

    return (
        <Button size='lg' kind='clear' className={styles.wrapper} disableInteractive onClick={handleClick}>
            <Icon name='ArrowLeftCircle_20' />
            {goBackActionText}
        </Button>
    );
};

export default GoBack;
